var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6293 9.18626L9.78546 7.96749C9.66398 7.91571 9.52896 7.90481 9.40074 7.9364C9.27252 7.968 9.15803 8.04039 9.07451 8.14269L7.81512 9.68139C5.83861 8.74948 4.24798 7.15885 3.31607 5.18234L4.85477 3.92294C4.95727 3.83958 5.02982 3.72509 5.06143 3.59681C5.09304 3.46853 5.082 3.33344 5.02997 3.21199L3.8112 0.368194C3.7541 0.23728 3.65311 0.130393 3.52564 0.065964C3.39817 0.00153493 3.25222 -0.0163977 3.11294 0.0152583L0.472274 0.624644C0.337998 0.655651 0.218197 0.731256 0.132423 0.839118C0.0466498 0.946981 -3.09316e-05 1.08073 1.53774e-08 1.21854C1.53774e-08 7.73135 5.2788 13 11.7815 13C11.9193 13.0001 12.0531 12.9534 12.161 12.8677C12.2689 12.7819 12.3446 12.662 12.3756 12.5277L12.985 9.88705C13.0164 9.7471 12.9981 9.60057 12.9332 9.47266C12.8683 9.34475 12.7608 9.24348 12.6293 9.18626Z",
    fill: "#00A0F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/PhoneIcon.7c82c06dbd0e73c394667afd1f03dc58.svg";
export { ForwardRef as ReactComponent };